import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Category } from '../../../models/category';

export const getCategoriesSuccess = createAction(
  '[Category] Get Categories Success',
  props<{ categories: Category[] }>()
);

export const getCategoriesError = createAction('[Category] Get Categories Error', props<{ err: HttpErrorResponse }>());

export const saveCategory = createAction('[Category] Save Category', props<{ label: string; studyId: number }>());

export const saveCategorySuccess = createAction('[Category] Save Category Success', props<{ newCategory: Category }>());

export const saveCategoryError = createAction('[Category] Save Category Error', props<{ err: HttpErrorResponse }>());

export const deleteCategory = createAction(
  '[Category] Delete Category',
  props<{ category: Category; studyId: number }>()
);

export const deleteCategorySuccess = createAction(
  '[Category] Delete Category Success',
  props<{ deletedCategory: Category }>()
);

export const deleteCategoryError = createAction(
  '[Category] Delete Category Error',
  props<{ err: HttpErrorResponse }>()
);
